/* Tidesy product page (sections/tidesy-product.liquid): option chips, gallery, tabs, looks, add-ons, sticky bar. */
(function () {
  var root = document.querySelector('[data-th-pp]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-pp-json]').textContent);
  var V = data.variants;
  var money = function (c) { return (c / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }); };
  var short = function (c) { return money(c).replace('.00', ''); };
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  var groups = $$('.th-pp-opt');
  var sel = groups.map(function (g) { var on = $('.th-pp-chip.on', g); return on ? on.dataset.val : null; });
  var frameIdx = -1;
  groups.forEach(function (g, i) { if (/frame/i.test($('.th-pp-opt-head b', g).textContent)) frameIdx = i; });

  var find = function (s) { return V.find(function (v) { return v.o.every(function (x, i) { return x === s[i]; }); }); };
  var current = find(sel) || V[0];

  /* "from +$3" next to each material heading */
  var minAll = Math.min.apply(null, V.map(function (v) { return v.price; }));
  $$('[data-groupnote]').forEach(function (em) {
    var vals = $$('.th-pp-chip[data-group="' + em.dataset.groupnote + '"]', groups[0]).map(function (c) { return c.dataset.val; });
    var prices = V.filter(function (v) { return vals.indexOf(v.o[0]) > -1; }).map(function (v) { return v.price; });
    if (!prices.length) return;
    var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
    em.textContent = hi === minAll ? '· included' : lo === minAll ? '· up to +' + short(hi - minAll) : (lo === hi ? '· +' : '· from +') + short(lo - minAll);
  });

  var main = $('.th-pp-main img'), mainLink = $('[data-main-link]');
  var showMain = function (full, big) {
    main.removeAttribute('srcset');
    main.src = full;
    mainLink.href = big || full;
  };
  var markThumb = function (btn) { $$('[data-thumbs] button').forEach(function (b) { b.classList.toggle('on', b === btn); }); };

  function render(moveImage) {
    var v = current;
    groups.forEach(function (g, i) {
      $$('.th-pp-chip', g).forEach(function (c) {
        c.classList.toggle('on', c.dataset.val === sel[i]);
        var s = sel.slice(); s[i] = c.dataset.val;
        var m = find(s);
        c.classList.toggle('na', !m || !m.avail);
      });
      var n = $('[data-optname]', g); if (n) n.textContent = sel[i];
    });
    $('[data-vid]').value = v.id;
    $('[data-price]').textContent = money(v.price);
    $('[data-pricenote]').textContent = v.avail ? v.title.split(' / ').join(' · ') : 'Sold out';
    var atc = $('[data-atc]');
    atc.disabled = !v.avail;
    atc.textContent = v.avail ? 'Add to cart' : 'Sold out';
    $('[data-stickyp]').textContent = money(v.price) + ' · ' + v.title;
    var vt = $('[data-variant-thumb]');
    if (v.full && vt) {
      vt.dataset.full = v.full; vt.dataset.big = v.big;
      var ti = vt.querySelector('img'); ti.removeAttribute('srcset'); ti.src = v.thumb;
      if (moveImage) { showMain(v.full, v.big); markThumb(vt); }
    }
    if (moveImage) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    updatePairs();
  }

  function choose(i, val) {
    sel[i] = val;
    var v = find(sel);
    if (!v) {
      v = V.find(function (x) { return x.o[i] === val && x.avail; }) || V.find(function (x) { return x.o[i] === val; });
      sel = v.o.slice();
    }
    current = v;
    render(true);
  }

  groups.forEach(function (g, i) {
    $$('.th-pp-chip', g).forEach(function (c) { c.addEventListener('click', function () { choose(i, c.dataset.val); }); });
  });

  /* gallery */
  $$('[data-thumbs] button').forEach(function (b) {
    b.addEventListener('click', function () { showMain(b.dataset.full, b.dataset.big); markThumb(b); });
  });
  var all = $('[data-showall]');
  if (all) all.addEventListener('click', function () { $$('.th-pp-more').forEach(function (b) { b.hidden = false; }); all.remove(); });

  /* quantity */
  var qty = $('[data-qty]');
  $$('[data-q]').forEach(function (b) {
    b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.q, 10)); });
  });

  /* screen tabs */
  $$('[data-tab]').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('[data-tab]').forEach(function (x) { x.classList.toggle('on', x === t); });
      $$('[data-pane]').forEach(function (p) { p.classList.toggle('on', p.dataset.pane === t.dataset.tab); });
    });
  });

  /* "your style" looks pick the faceplate + frame */
  $$('.th-pp-combo').forEach(function (c) {
    c.addEventListener('click', function () {
      var s = sel.slice(); s[0] = c.dataset.o1; if (s.length > 1) s[1] = c.dataset.o2;
      var v = find(s) || V.find(function (x) { return x.o[0] === s[0] && x.o[1] === s[1]; });
      if (!v) return;
      sel = v.o.slice(); current = v; render(true);
      $('.th-pp-buy').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* add-ons follow the frame color: black kit for black frames, white otherwise; stand matches the frame */
  function pick(kind) {
    var frame = frameIdx > -1 ? sel[frameIdx] : 'White';
    if (kind === 'kit') {
      var col = frame === 'Black' ? 'Black' : 'White';
      return (data.kit || []).find(function (k) { return k.t.indexOf(col) === 0 && k.t.indexOf('3 ft') > -1; }) || (data.kit || [])[0];
    }
    return (data.stand || []).find(function (k) { return k.t === frame + ' PLA'; }) || (data.stand || [])[0];
  }
  function updatePairs() {
    $$('[data-pair]').forEach(function (p) {
      var k = pick(p.dataset.pair), b = $('[data-add]', p);
      if (k && !b.classList.contains('done')) b.dataset.id = k.id;
      if (k && b.title !== undefined) b.title = k.t;
    });
  }
  $$('[data-pair] [data-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.classList.contains('done')) { location.href = '/cart'; return; }
      b.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.id), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; b.classList.add('done'); b.textContent = 'Added · view cart'; })
        .catch(function () { b.textContent = 'Try again'; })
        .then(function () { b.disabled = false; });
    });
  });

  /* sticky add-to-cart on phones */
  var atcBtn = $('[data-atc]'), sticky = $('[data-sticky]');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      sticky.classList.toggle('show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }).observe(atcBtn);
  }
  $('[data-stickyatc]').addEventListener('click', function () {
    var f = document.getElementById('th-pp-form');
    if (f.requestSubmit) f.requestSubmit(atcBtn); else atcBtn.click();
  });

  render(false);
})();